module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-size": "75%"
    },
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copy"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("First Published in Great Britain in 2016 by"), _c('br'), _vm._v("Pen & Sword Aviation"), _c('br'), _vm._v("an imprint of"), _c('br'), _vm._v("Pen & Sword Books Ltd"), _c('br'), _vm._v("47 Church Street, Barnsley, South Yorkshire S70 2AS")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © Pen & Sword Books 2016"), _c('br'), _vm._v("ISBN: 9781473837713."), _c('br'), _vm._v("\nPDF ISBN: 9781473881174."), _c('br'), _vm._v("\nEPUB ISBN: 9781473881167."), _c('br'), _vm._v("\nPRC ISBN: 9781473881150.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("The right of Martin W Bowman to be identified as author of this work"), _c('br'), _vm._v("has been asserted by him in accordance with the"), _c('br'), _vm._v("Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("A CIP catalogue record for this book is"), _c('br'), _vm._v("available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in"), _c('br'), _vm._v("any form or by any means, electronic or mechanical including photocopying,"), _c('br'), _vm._v("recording or by any information storage and retrieval system, without"), _c('br'), _vm._v("permission from the Publisher in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Typeset in 10/12pt Palatino"), _c('br'), _vm._v("by GMS Enterprises PE3 8QQ")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Printed and bound in England by"), _c('br'), _vm._v("CPI Group (UK) Ltd, Croydon, CR0 4YY")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Pen & Sword Books Ltd incorporates the Imprints of Pen & Sword"), _c('br'), _vm._v("Aviation, Pen & Sword Family History, Pen & Sword Maritime, Pen & Sword"), _c('br'), _vm._v("Military, Pen & Sword Discovery, Wharncliffe Local History, Wharncliffe"), _c('br'), _vm._v("True Crime, Wharncliffe Transport, Pen & Sword Select, Pen & Sword"), _c('br'), _vm._v("Military Classics, Leo Cooper, The Praetorian Press, Remember When,"), _c('br'), _vm._v("Seaforth Publishing and Frontline Publishing.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("For a complete list of Pen & Sword titles please contact"), _c('br'), _vm._v("PEN & SWORD BOOKS LIMITED")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("47 Church Street, Barnsley, South Yorkshire, S70 2AS, England"), _c('br'), _vm._v("E-mail: "), _c('a', {
    attrs: {
      "href": "mailto:enquiries@pen-and-sword.co.uk"
    }
  }, [_vm._v("enquiries@pen-and-sword.co.uk")]), _c('br'), _vm._v("Website: "), _c('a', {
    attrs: {
      "href": "http://www.pen-and-sword.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.pen-and-sword.co.uk")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 60
// module chunks = 0